export const GET_ADMIN_USER_LIST = 'GET_ADMIN_USER_LIST';
export const GET_ADMIN_USER_LIST_SUCCESS = 'GET_ADMIN_USER_LIST_SUCCESS';
export const GET_ADMIN_USER_LIST_FAILURE = 'GET_ADMIN_USER_LIST_FAILURE';

export const GET_ADMIN_USER_LIST_SEARCH = 'GET_ADMIN_USER_LIST_SEARCH';
export const GET_ADMIN_USER_LIST_SEARCH_SUCCESS =
    'GET_ADMIN_USER_LIST_SEARCH_SUCCESS';
export const GET_ADMIN_USER_LIST_SEARCH_FAILURE =
    'GET_ADMIN_USER_LIST_SEARCH_FAILURE';

// get associated account
export const GET_ADMIN_ASSOCIATED_ACCOUNT = 'GET_ADMIN_ASSOCIATED_ACCOUNT';
export const GET_ADMIN_ASSOCIATED_ACCOUNT_SUCCESS =
    'GET_ADMIN_ASSOCIATED_ACCOUNT_SUCCESS';
export const GET_ADMIN_ASSOCIATED_ACCOUNT_FAILURE =
    'GET_ADMIN_ASSOCIATED_ACCOUNT_FAILURE';

//get user roles
export const GET_USER_ROLE = 'GET_USER_ROLE';
export const GET_USER_ROLE_SUCCESS = 'GET_USER_ROLE_SUCCESS';
export const GET_USER_ROLE_FAILURE = 'GET_USER_ROLE_FAILURE';

//get area region district terittory list

export const GET_ARDT_LIST = 'GET_ARDT_LIST';
export const GET_ARDT_LIST_SUCCESS = 'GET_ARDT_LIST_SUCCESS';
export const GET_ARDT_LIST_FAILURE = 'GET_ARDT_LIST_FAILURE';
export const GET_ARDT_REGION_LIST_SUCCESS = 'GET_ARDT_REGION_LIST_SUCCESS';
export const GET_ARDT_DISTRICT_LIST_SUCCESS = 'GET_ARDT_DISTRICT_LIST_SUCCESS';
export const GET_ARDT_SUBDISTRICT_LIST_SUCCESS =
    'GET_ARDT_SUBDISTRICT_LIST_SUCCESS';
export const GET_ARDT_TERRITORY_LIST_SUCCESS =
    'GET_ARDT_TERRITORY_LIST_SUCCESS';
export const GET_ARDT_LEVEL4_LIST_SUCCESS = 'GET_ARDT_LEVEL4_LIST_SUCCESS';
export const RESET_ARDT_LIST = 'RESET_ARDT_LIST';
// get associated physician

export const GET_ADMIN_ASSOCIATED_PHYSICIAN = 'GET_ADMIN_ASSOCIATED_PHYSICIAN';
export const GET_ADMIN_ASSOCIATED_PHYSICIAN_SUCCESS =
    'GET_ADMIN_ASSOCIATED_PHYSICIAN_SUCCESS';
export const GET_ADMIN_ASSOCIATED_PHYSICIAN_FAILURE =
    'GET_ADMIN_ASSOCIATED_PHYSICIAN_FAILURE';

// get new assingment

export const GET_NEW_ASSIGNMENT = 'GET_NEW_ASSIGNMENT';
export const GET_NEW_ASSIGNMENT_SUCCESS = 'GET_NEW_ASSIGNMENT_SUCCESS';
export const GET_NEW_ASSIGNMENT_FAILURE = 'GET_NEW_ASSIGNMENT_FAILURE';
export const CLEAR_NEW_ASSIGNMENT = 'CLEAR_NEW_ASSIGNMENT';
// update user api
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const ADD_ADMIN_PROXIES = 'ADD_ADMIN_PROXIES';
export const ADD_ADMIN_PROXIES_SUCCESS = 'ADD_ADMIN_PROXIES_SUCCESS';
export const ADD_ADMIN_PROXIES_FAILURE = 'ADD_ADMIN_PROXIES_FAILURE';

export const UPDATE_ADMIN_PROXY = 'UPDATE_ADMIN_PROXY';
export const UPDATE_ADMIN_PROXY_SUCCESS = 'UPDATE_ADMIN_PROXY_SUCCESS';
export const UPDATE_ADMIN_PROXY_FAILURE = 'UPDATE_ADMIN_PROXY_FAILURE';

export const GET_ADMIN_PROXY_LIST = 'GET_ADMIN_PROXY_LIST';
export const GET_ADMIN_PROXY_LIST_SUCCESS = 'GET_ADMIN_PROXY_LIST_SUCCESS';
export const GET_ADMIN_PROXY_LIST_FAILURE = 'GET_ADMIN_PROXY_LIST_FAILURE';

export const REVOKE_ADMIN_PROXIES = 'REVOKE_ADMIN_PROXIES';
export const REVOKE_ADMIN_PROXIES_SUCCESS = 'REVOKE_ADMIN_PROXIES_SUCCESS';
export const REVOKE_ADMIN_PROXIES_FAILURE = 'REVOKE_ADMIN_PROXIES_FAILURE';

export const IMPERSONATE_ADMIN_PROXY = 'IMPERSONATE_ADMIN_PROXY';
export const IMPERSONATE_ADMIN_PROXY_SUCCESS =
    'IMPERSONATE_ADMIN_PROXY_SUCCESS';
export const IMPERSONATE_ADMIN_PROXY_FAILURE =
    'IMPERSONATE_ADMIN_PROXY_FAILURE';

export const TERMINATE_ADMIN_PROXY = 'TERMINATE_ADMIN_PROXY';
export const TERMINATE_ADMIN_PROXY_SUCCESS = 'TERMINATE_ADMIN_PROXY_SUCCESS';
export const TERMINATE_ADMIN_PROXY_FAILURE = 'TERMINATE_ADMIN_PROXY_FAILURE';

export const SET_UPDATE_POPUP = 'SET_ADMIN_UPDATE_POPUP';
export const SET_ADMIN_SEARCH = 'SET_ADMIN_SEARCH';
export const SET_ADMIN_FILTER = 'SET_ADMIN_FILTER';

export const SET_FILTER_PAGE = 'SET_ADMIN_FILTER_PAGE';
export const GET_ADMIN_DATA_FROM_SEARCH = 'GET_ADMIN_DATA_FROM_SEARCH';
export const GET_ADMIN_USER_LIST_FROM_SEARCH_SUCCESS =
    'GET_ADMIN_USER_LIST_FROM_SEARCH_SUCCESS';
export const CLEAR_SEARCH_RESULT = 'CLEAR_SEARCH_RESULT';
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export const SET_ADMIN_SEARCH_PARAMS = 'SET_ADMIN_SEARCH_PARAMS';

export const SET_USER_ROLE_CHANGE = 'SET_USER_ROLE_CHANGE';
export const SET_LOGGED_USER_ROLE_CHANGE = 'SET_LOGGED_USER_ROLE_CHANGE';

export const GET_ADMIN_PROXY_USER_LIST = 'GET_ADMIN_PROXY_USER_LIST';
export const SET_IMPERSONATION_STATUS = 'SET_IMPERSONATION_STATUS';
export const GET_ADMIN_PROXY_USER_LIST_SUCCESS =
    'GET_ADMIN_PROXY_USER_LIST_SUCCESS';
export const GET_ADMIN_PROXY_USER_LIST_FAILURE =
    'GET_ADMIN_PROXY_USER_LIST_FAILURE';

export const SHOW_LOCAL_EXPANDED_VIEW = 'SHOW_LOCAL_EXPANDED_VIEW';
export const SET_APPLIED_VIEW_ADMIN_FILTER = 'SET_APPLIED_VIEW_ADMIN_FILTER';
export const RESET_ROLES = 'RESET_ROLES';
export const RESET_TERRITORY = 'RESET_TERRITORY_ADMIN';
export const SET_CLEAR_FILTER = 'SET_CLEAR_FILTER_ADMIN';
export const SET_FILTER_VIEW_ADMIN = 'SET_FILTER_VIEW_ADMIN';
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE_ADMIN';
export const GET_SALES_ORG_VIEW = 'GET_SALES_ORG_VIEW';
export const GET_DISTRICT_SUCCESS = 'GET_ADMIN_DISTRICT_SUCCESS';
export const GET_DISTRICT_FAILURE = 'GET_ADMIN_DISTRICT_FAILURE';
export const GET_DISTRICT = 'GET_ADMIN_DISTRICT';
export const GET_SALES_ORG_VIEW_SUCCESS = 'GET_SALES_ORG_VIEW_SUCCESS';
export const GET_SALES_ORG_VIEW_FAILURE = 'GET_SALES_ORG_VIEW_FAILURE';
export const GET_TERRITORY = 'GET_ADMIN_TERRITORY';
export const GET_TERRITORY_SUCCESS = 'GET_ADMIN_TERRITORY_SUCCESS';
export const GET_TERRITORY_FAILURE = 'GET_ADMIN_TERRITORY_FAILURE';
export const SET_ADMIN_FILTERS = 'SET_ADMIN_FILTERS';
export const SET_POPUPCLOSE_FROM_HEADER = 'SET_POPUPCLOSE_FROM_HEADER';
export const SET_ADMIN_FILTER_PARAM_VALUES = 'SET_ADMIN_FILTER_PARAM_VALUES';
export const SET_FILTER_PARAMS = 'SET_ADMIN_FILTER_PARAMS';
export const SET_MORE_CLICK = 'SET_ADMIN_MORE_CLICK';
export const GET_FILTER_DATA = 'GET_ADMIN_FILTER_DATA';
export const SET_CHECKBOX_CHECKED = 'SET_CHECKBOX_CHECKED';
export const SET_POP_DONE = 'SET_POP_DONE';
export const SET_SELECTED_SALESORG = 'SET_SELECTED_SALESORG';
export const SET_DEFAULT = 'SET_DEFAULT';
export const SET_SALESORGVIEW_DATA = 'SET_SALESORGVIEW_DATA';
export const UPDATE_SALES_ORG = 'UPDATE_SALES_ORG';
export const SET_FILTER_DETAILS_SUCCESS = 'SET_FILTER_DETAILS_SUCCESS';
export const SET_FILTER_DETAILS_FAILURE = 'SET_FILTER_DETAILS_FAILURE';
export const SET_SELECTED_VALUE = 'SET_SELECTED_VALUE';
export const GET_FILTER_DETAILS_SUCCESS = 'GET_FILTER_DETAILS_SUCCESS';
export const GET_FILTER_DETAILS_FAILURE = 'GET_FILTER_DETAILS_FAILURE';
export const GET_FILTER_DETAILS = 'GET_FILTER_DETAILS';
export const SET_FILTER_DETAILS = 'SET_FILTER_DETAILS';

export const SET_TAB_ADMIN_PROXY = 'SET_TAB_ADMIN_PROXY';
export const SET_SHOW_PROXY = 'SET_SHOW_PROXY';
export const SET_PROXYTAB_DATA = 'SET_PROXYTAB_DATA';

export const SET_FILER_AFTER_IMPERSONATION = 'SET_FILER_AFTER_IMPERSONATION';
export const CLEAR_ADMIN_FILTERS = 'CLEAR_ADMIN_FILTERS';
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
export const SET_AREA = 'SET_AREA';
export const IS_SALES_ORG_INITIALIZED = 'IS_SALES_ORG_INITIALIZED';